import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { reducer as wallet } from './wallet'

export default history => combineReducers({
    router: connectRouter(history),
    wallet
});